import RoundHistory from '@/containers/RoundHistory';

const RoundHistoryPage = props => {
  return <RoundHistory {...props} />;
};

export default RoundHistoryPage;
